import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { Paper, Typography, TextField, Divider, Grid, Button } from "@material-ui/core";
import Logo from '../../images/NavyLogo.png'
import LogoText from '../../images/NavyLL.png'
import { } from "@material-ui/icons";
import creds from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';

const styles = theme => ({
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      margin: 'auto',
      width: '50%',
      height: 'auto',
      overflowX: 'auto'
    
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center', 
        alignItems: 'center',
        padding: 70, 
        
      },
      textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '75%',
        align: 'center',
      },
      paper: { 
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        overflowX: 'auto'
      },
      menu: {
        width: 200,
      },
      button: {
        margin: theme.spacing.unit,
      },
      input: {
        display: 'none',
      },
    
});

class Login extends Component{
    constructor(props){ 
        super(props)
        this.state = {
        email: '',
        password: ''
    }; 
    this.login = this.login.bind(this)
    }
    

    // login() { 
    //     creds.fb.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
    //         .then( () => {
    //             this.currentUser()
    //                })
    //         .catch((error) => {
    //             console.log(error)
            
    //             if (new String(error).includes('identifier')) {
    //                 this.setState({emailError: true})
    //             } else 
    //             if (new String(error).includes('password')) {
    //                 this.setState({passwordError: true})
    //             }
    //         }) 
    // };

    login() { 
        this.OGCheck(this.state.password)
        if (false) {
            console.log('output was true, logging in now', this.state.OGPassword)
            creds.fb.auth().signInWithEmailAndPassword(this.state.email, this.state.OGPassword)
            .then( () => {
                this.currentUser()
                   })
            .catch((error) => {
                console.log(error)
            
                if (new String(error).includes('identifier')) {
                    return this.setState({emailError: true})
                } else 
                if (new String(error).includes('password')) {
                    // Does the entered password match the NEW password in the DB
                    console.log(this.OGCheck(this.state.password))//DEBUG
                    if (this.OGCheck(this.state.password)){
                        window.alert('HERE')
                        //if it does then, sign in using the OG password
                        creds.fb.auth().signInWithEmailAndPassword(this.state.email, this.state.OGPassword)
                        .then( () => {
                            this.currentUser()
                        })
                        //Add catch statement after (if even necessary)
                    }
                    //if not then send output
                    return this.setState({passwordError: true}) // this is the output
                } else {
                    window.alert('There was a problem signing you in. Please check your account details & try again.')
                    window.location.reload()
                }
            }) 
        } else {
            // return this.setState({passwordError: true}) // this is the output
        }
        
    };

    OGCheck = async (password) => { 
        console.log('Password enetered: ', password)
        var output
        var ogPass
        var ref = await db.collection('Users').where('email', '==', this.state.email).get()
        var snapshot = ref
        console.log(snapshot)
        if (snapshot.docs.length == 1) {
            var data = snapshot.docs[0].data()
            console.log(data)
            ogPass = data.OGPassword
            if (password == data.password){
                console.log('Password is correct')
                if (data.OGPassword) {
                    creds.fb.auth().signInWithEmailAndPassword(this.state.email, data.OGPassword)
                    .then( () => {
                        this.currentUser()
                        })
                    .catch((error) => {
                        console.log(error)
                        if (new String(error).includes('identifier')) {
                            return this.setState({emailError: true})
                        } else 
                        if (new String(error).includes('password')) {
                            // Does the entered password match the NEW password in the DB
                            return this.setState({passwordError: true})
                        }
                    })
                } else {
                    creds.fb.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
                    .then( () => {
                        this.currentUser()
                        })
                    .catch((error) => {
                        console.log(error)
                        if (new String(error).includes('identifier')) {
                            return this.setState({emailError: true})
                        } else 
                        if (new String(error).includes('password')) {
                            // Does the entered password match the NEW password in the DB
                            return this.setState({passwordError: true})
                        }
                    })
                } 
            } else { 
                return this.setState({passwordError: true})
            }
        } else {
            return this.setState({emailError: true})
        }
        
        console.log(output, ogPass, password, 'line 144')
        return output
    }

    keypressed = (e) => {
        if (e.key == 'Enter'){
            this.login()
        }
    }

    handleChange = name => event => {
        this.setState({
          [name]: event.target.value,
          emailError: false,
          passwordError: false
        });
    };

    currentUser = () => {
        var user = creds.fb.auth().currentUser 
        var actType = ''   
        user
        {(user) ? (
          this.setState({
            currentEmail: user.email,
            currentUID: user.uid,
            me: {
              'email': user.email,
              'uid': user.uid
            },
          }),
          sessionStorage.setItem('email', user.email),
          sessionStorage.setItem('uid', user.uid),
          db.collection('Users').where('UID', '==', user.uid).get()
           .then(snapshot => { 
                console.log(snapshot.docs)
                sessionStorage.setItem('AccountType', snapshot.docs[0].data().accountType)
                actType = snapshot.docs[0].data().accountType
                window.location.replace('/' + user.uid + '/' + actType + '/Dashboard')
           })
         )
          :
          <div>
         </div>
        } 
    }

    render(){

        const { classes } = this.props;
        

        return (
            

                <div style={{marginTop: '2.5%'}}>
                    <Paper className={classes.root} elevation={1}>
                        <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='center'
                            style={{overflowX: 'auto'}}
                        >
                        <form className={classes.container} align='center'>
                            <Grid item xs={12} style={{ paddingBottom: 100 }}>
                                <div style={{marginRight: 10}}>
                                    <img height={64} width={64} src={Logo}/>
                                </div>
                                <div style={{marginRight: 10, marginBottom: '10%'}}>
                                    <img height={60} width='auto' src={LogoText}/>
                                </div>
                                <Paper className={classes.paper}>
                                    <Typography variant="headline">
                                        Sign in
                                        <Divider/>
                                    </Typography>
                                    <div style={{ width: '100%', paddingTop: 50, paddingBottom: 25 }}>
                                    <TextField
                                        id="email"
                                        label="Email"
                                        className={classes.textField}
                                        margin="normal"
                                        align='center'
                                        value={this.state.email}
                                        error={this.state.emailError}
                                        onChange={this.handleChange('email', this.value)} 
                                        onKeyPress={this.keypressed}
                                    />
                                    </div>
                                    <br/>
                                    <div style={{ paddingBottom: 25 }}>
                                    <TextField
                                        id="password-input"
                                        label="Password"
                                        className={classes.textField}
                                        type="password"
                                        autoComplete="current-password"
                                        margin="normal"
                                        value={this.state.password}
                                        error={this.state.passwordError}
                                        onChange={this.handleChange('password', this.value)} 
                                        onKeyPress={this.keypressed}
                                    />
                                    </div>
                                    <Button variant="contained" className={classes.button} onClick={ () => this.login()} onKeyPress={this.keypressed}>
                                        login
                                    </Button>
                                    {/* <Button variant="contained" className={classes.button} onClick={ () => window.alert(this.state.password)}>
                                        Recovery
                                    </Button> */}
                                </Paper>
                            </Grid>
                        </form>
                        </Grid>
                    </Paper>
                </div>
            
        )
    }
}

export default withStyles(styles)(Login)


// WEBPACK FOOTER //
// ./src/components/loginPaper/login.jsx